vcDashboardRegistry.register("ticketlist", {
    noTitle: false,
    defaults: { w: 8, h: 8, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: false },
    settingsDefaults: { FreeText: "" },
    get popupTitle() { return vcDashboardResources.get("ticketlist"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-ticketlist-wrapper'></div>");
    },
    loadChart: function ($item, settings) {
        var resolved = vcDashboardPopup.resolveEffectiveSettings($item, settings);
        var obj = $item.find(".dashboard-ticketlist-wrapper");
        obj.empty();
        obj.css("width", "100%");
        obj.height($item.find(".dashboard-item-content").height());
        obj.TicketList({ invokeType: "addVisualBase", parameter: { 'LoggerID': resolved.effectiveSettings.LoggerId, 'Simple': true }, deviceType: 2 });



    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    buildFields: function (currentSettings, $el) {
        var fields = [];
        //fields.push({ key: "FreeText", label: vcDashboardResources.get("freeText"), type: "richtext", rows: 14 });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});
